import { Navigate } from "react-router-dom";

import UnassignedMailsPage from "./UnassignedMailsPage";

export function WhatsAppConnectRedirect() {
  return <Navigate to="/dashboard?configuracion=cuentas-linkeadas" replace />;
}

export default function UnassignedHubPage() {
  return <UnassignedMailsPage />;
}

/* Sin asignar de WhatsApp oculto a pedido del cliente (16 oct 2026). Para volver a mostrarlo,
   reemplazar el componente de arriba por el de abajo y descomentar en el back las rutas
   `threads/unassigned/` y `threads/<id>/assign/`, en el front `listUnassignedThreads` y
   `assignThread` de whatsapp.service.js, `unassignedWhatsAppPath` de whatsappRoutes.js y el
   aviso de mensajes sin lead en `_notify_inbound`.

import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

import LeadChannelTabs, {
  CHANNEL_MAIL,
  CHANNEL_WHATSAPP,
} from "../components/leads/whatsapp/LeadChannelTabs";
import UnassignedWhatsAppThreads from "../components/whatsapp/UnassignedWhatsAppThreads";
import { whatsappService } from "../services/whatsapp.service";
import UnassignedMailsPage from "./UnassignedMailsPage";

import styles from "../styles/pages/ChannelHub.module.css";

export const UNASSIGNED_WHATSAPP_INTRO =
  "Conversaciones de WhatsApp de teléfonos que no son de ninguna persona de tus leads. Vinculalas a un lead existente o creá uno nuevo.";

export default function UnassignedHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [hasNumbers, setHasNumbers] = useState(false);
  const [notice, setNotice] = useState(null);
  const requestedWhatsApp = searchParams.get("canal") === "whatsapp";

  useEffect(() => {
    let mounted = true;
    whatsappService
      .listAccounts()
      .then(({ results }) => {
        if (mounted) setHasNumbers(results.length > 0);
      })
      .catch(() => {
        if (mounted) setHasNumbers(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!hasNumbers && !requestedWhatsApp) return <UnassignedMailsPage />;

  const channel = requestedWhatsApp ? CHANNEL_WHATSAPP : CHANNEL_MAIL;

  return (
    <div className={styles.hub}>
      <div className={styles.tabs}>
        <LeadChannelTabs
          channel={channel}
          onChange={(next) => {
            setNotice(null);
            setSearchParams(next === CHANNEL_WHATSAPP ? { canal: "whatsapp" } : {});
          }}
        />
      </div>
      <div className={styles.body}>
        {channel === CHANNEL_WHATSAPP ? (
          <div className={styles.pane}>
            <h1 className={styles.title}>Sin asignar</h1>
            <p className={styles.subtitle}>{UNASSIGNED_WHATSAPP_INTRO}</p>
            {notice && (
              <p className={styles.notice} role="status">
                {notice}
              </p>
            )}
            <UnassignedWhatsAppThreads
              onAssigned={(thread, lead) =>
                setNotice(
                  `Vinculaste la conversación de ${thread.contact_name || thread.contact_phone} al lead ${lead.lead_name}.`,
                )
              }
            />
          </div>
        ) : (
          <UnassignedMailsPage />
        )}
      </div>
    </div>
  );
}
*/
